import React, { useState, useEffect } from 'react';
import * as PropTypes from "prop-types";
import Card from "../../Card/Card";
import CardHeader from "../../Card/CardHeader";
import CardIcon from "../../Card/CardIcon";
import CardBody from "../../Card/CardBody";
import styles from "../../../assets/jss/material-dashboard-pro-react/views/chartsStyle";
import TableChartIcon from '@mui/icons-material/TableChart';
import SweetAlert from "react-bootstrap-sweetalert";
import Button from "@mui/material/Button";
import MenuIcon from "@mui/icons-material/Menu";
import { Menu, MenuItem } from "@mui/material";
import { tooltip } from "../../../assets/jss/material-dashboard-pro-react";
import sweetAlertStyle from "../../../assets/jss/material-dashboard-pro-react/views/sweetAlertStyle";
import { CSVLink } from "react-csv";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import "../../../assets/css/Charts/fullscreen.css";
import {  makeStyles } from '@mui/styles';
import * as locales from '@mui/material/locale';
import CustomNoData from "./CustomNoData";

import "../../../assets/css/Charts/dataTable.css";
import DataTable from "react-data-table-component";
import zipcelx from 'zipcelx';

const useStyles = makeStyles(styles);

const cardHeaderStyle = {
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'space-between',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    alignItems: 'flex-start',
}
const style = { tooltip };
const tooltipStyle = {
    fontSize: '1rem',
    fontFamily: '"Source Sans Pro",sans-serif',
    color: ' #3c4858',
    display: "block", marginTop: "-50px", width: "25rem"
};
const UseSweetAlertStyle = makeStyles(sweetAlertStyle);
const menuButtonStyle = {
    float: "right",
    position: "relative",
    marginRight: "-0.5rem",
    paddingTop: "9px",
    fontSize: '1.2rem',
    fontFamily: '"Source Sans Pro",sans-serif',
};
const downloadCsvButton = {
    textDecoration: 'none',
    color: 'rgb(0 0 0 / 87%)'
}
const menuItemStyle = {
    fontSize: '1.2rem',
    fontFamily: '"Source Sans Pro",sans-serif',
}
const useStylesToolbar = makeStyles((theme) => ({
    root: {
        '&.MuiDataGrid-root': {
            color: '#000000',
            backgroundColor: '#FFFFFF',
            marginBottom: "-9px",
        },
        '&.MuiDataGrid-toolbar': {
            color: '#000000',
            backgroundColor: '#FFFFFF',
            marginBottom: "-9px",
        },
        '& .MuiButtonBase-root, .MuiButton-label': {
            color: '#000000',
        }
    }
}));

const customStyles = {
    rows: {
        style: {
            minHeight: '30px', // override the row height
        }
    },

    head: {
        style: {
            fontWeight: '600 !important',
        },
    },
    header: {
        style: {
            fontWeight: '600 !important',
        },
    },
    headRow: {
        style: {
            fontWeight: '600 !important',
        }
    },
    headCells: {
        style: {
            paddingLeft: '8px', // override the cell padding for data cells
            paddingRight: '8px',
            fontWeight: '600 !important',
            fontSize: '13px'
        },
    },
    cells: {
        style: {
            padding: '8px', // override the cell padding for head cells
        },
    },
};


export default function CustomTableCharts(props) {
    const classes = useStyles();
    const styledTableToolbar = useStylesToolbar();
    const sweetClasse = UseSweetAlertStyle();
    const [openMenu, setOpenMenu] = useState(null);
    const [alert, setAlert] = useState(null);
    const [csvHeaders, setCsvHeaders] = useState([]);
    const [csvLines, setCsvLines] = useState([]);
    let headers = [];

    const handle = useFullScreenHandle();

    useEffect(() => {
        props.headers.map(header => {
            let label = header.headerName;
            let key = header.field;
            header.label = label;
            header.key = key;
            const newHeader = { label: header.headerName, key: header.field };
            return headers = headers.concat({ ...newHeader });
        });
        setCsvHeaders(headers);
        let csvlinestmp = [];
        props.lines.map(row => {
            let newrow = {...row};
            props.headers.map((header, index) => {
                if (newrow[header.field]) {
                    if (typeof newrow[header.field] === 'number') {
                        newrow[header.field] = ('' + newrow[header.field]).replace('.', ',');
                        //newrow[header.field] = ('' + newrow[header.field]).replace(' ', '');
                    }
                }
            });
            csvlinestmp.push(newrow);
        });
        setCsvLines(csvlinestmp);
    }, []);

    const getFullscreen = () => {
        handleClose();
    };

    const downloadCsv = () => {
        handleClose();
    };
    const hideAlert = () => {
        setAlert(null);
    };
    const getTooltipHelp = () => {
        const tooltipAlert = (
            <SweetAlert
                style={tooltipStyle}
                title=""
                onConfirm={() => hideAlert()}
                onCancel={() => hideAlert()}
                confirmBtnCssClass={sweetClasse.button + " " + sweetClasse.info}
            >
                {props.tooltipHelp}
            </SweetAlert>
        );

        setAlert(tooltipAlert);
        handleClose();
    };
    const handleClick = (event) => {
        setOpenMenu(event.currentTarget);
    };
    const handleClose = () => {
        setOpenMenu(null);
    };

    const downloadXlsx = () => {
        var div = document.createElement('div'),
            name,
            xlsxRows = [],
            rows;

        var headers = props.headers.map((row, rowindex) => {
            return {
                type: 'string',
                value: row.headerName,
            }
        });

        xlsxRows = props.lines.map((row, rowindex) => {
            return props.headers.map((header, index) => {
                if (row[header.field]) {
                    return {
                        type: typeof row[header.field] === 'number' ? 'number' : 'string',
                        value: row[header.field]
                    };
                }
                else {
                    return {
                        type: 'string',
                        value: '',
                    };
                }
            });
        });

        xlsxRows.unshift(headers);

        zipcelx({
            filename: props.tableTitle,
            sheet: {
                data: xlsxRows
            }
        });
        handleClose();
    };
   // console.log(props.category,props.rowCount);
    return (
        props.lines.length > 0 ?
            (
                <Card raised={true} chart style={{ marginTop: '15px', marginBottom: '40px' }}>
                    {/* <Card raised={true} chart> */}
                    <CardHeader color="warning" icon style={cardHeaderStyle}>
                        <CardIcon color="warning">
                            <TableChartIcon />
                        </CardIcon>
                        <h4 className={classes.cardIconTitle}>
                            {props.tableTitle}
                        </h4>
                        <div>
                            <Button
                                aria-controls="chart-menu"
                                aria-haspopup="true"
                                onClick={handleClick}
                                justicon={"true"}
                                style={menuButtonStyle}
                            >
                                <MenuIcon />
                            </Button>
                            <Menu
                                id="simple-menu"
                                className={"menu-chart"}
                                anchorEl={openMenu}
                                keepMounted
                                open={Boolean(openMenu)}
                                onClose={handleClose}
                                style={menuItemStyle}
                            >
                                <MenuItem onClick={getTooltipHelp} key={Math.random()}>
                                    Aide sur le graphique
                                </MenuItem>
                                <MenuItem onClick={handle.enter} key={Math.random()}>
                                    <span onClick={getFullscreen}>  Plein écran</span>
                                </MenuItem>
                                <MenuItem onClick={downloadXlsx} key={`downCsv${Math.random()}`}>
                                    Télécharger en XLSX
                                </MenuItem>
                                <MenuItem onClick={downloadCsv} key={Math.random()}>
                                    <CSVLink
                                        className={'csv'} data={csvLines}
                                        headers={csvHeaders} style={downloadCsvButton}
                                        filename={`${props.tableTitle}.csv`} target="_blank"
                                        separator={";"}
                                    >
                                        Télécharger en CSV
                                    </CSVLink>
                                </MenuItem>
                            </Menu>
                        </div>
                        {alert}
                    </CardHeader>
                    <CardBody>

                        <div>
                            <FullScreen handle={handle} className={'fullscreen-table'}>
                                <DataTable
                                    columns={props.headers}
                                    data={props.lines}
                                    pagination
                                    striped={true}
                                    // noHeader={true}
                                    // subHeader
                                    paginationComponentOptions={
                                        {
                                            noRowsPerPage: false,
                                            rowsPerPageText: "Lignes par page",
                                            rangeSeparatorText: "sur",
                                            selectAllRowsItem: false,
                                            selectAllRowsItemText: "Selectionner toutes les lignes"
                                        }
                                    }
                                    paginationPerPage={(props.category && props.category==8)? props.rowCount : 10}
                                    paginationRowsPerPageOptions={(props.category && props.category==8)? [12, 24, 36, 48, 60] : [10, 15, 20, 25, 30]}
                                    customStyles={customStyles}
                                />
                            </FullScreen>
                        </div>

                    </CardBody>
                </Card>
            ) : (
                <CustomNoData chartTitle={props.tableTitle} />
            )
    );
}

CustomTableCharts.propTypes = {
    tableTitle: PropTypes.string,
    headers: PropTypes.arrayOf(PropTypes.object),
    lines: PropTypes.arrayOf(PropTypes.object),
    tooltipHelp: PropTypes.string,
    rowCount: PropTypes.number,
}
